<template>
  <div class="home-content"  v-loading="homeLoading" element-loading-background="rgba(0, 0, 0, 0.5)">
    <ak-header :pageType="'homeContainer'" @homeSecurity="fanhui"></ak-header>
    <el-row :gutter="12">
      <el-col :span="4">
        <div class="home-left">
        <div class="overall overallHeader">
          <h3 class="home-tit">营运车辆总数</h3>
          <div class="home-monitor">
            <div class="home-monitor-list">
              <ul class="home-monitor-num">
                  <li>{{CarCount.totalCarCount || '0'}}</li>
                  <!-- <li v-for="(item,index) in shuju1" :key="index">{{item=='n'?"":item}}</li> -->
                  &nbsp;&nbsp;台
              </ul>
            </div>
          </div>
        </div>
      </div>
      </el-col>
      <el-col :span="16">
        <div class="home-left">
          <div class="overall overallHeader">
            <h3 class="home-tit"></h3>
            <div class="home-monitor">
              <div class="home-monitor-list" style="    display: flex;align-items: baseline;font-size: .57rem; margin-top: 0.65rem;">
                <span style="color: #00dfff;">实时在线运行车辆</span>
                <ul class="home-monitor-num" style="width: 6rem;font-size: 0.78rem;line-height: 1.78rem;">
                  <!-- <li >00000000764 </li> -->
                  <li>{{CarCount.onlineCarCount || '0'}}</li>
                  <!-- <li v-for="(item,index) in shuju2" :key="index">{{item=='n'?"":item}}</li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="home-left">
          <div class="overall overallHeader">
            <h3 class="home-tit">总计运送货物批次</h3>
            <div class="home-monitor">
              <div class="home-monitor-list">
                <ul class="home-monitor-num">
                  <li >0 </li>
                  <!-- <li v-for="(item,index) in shuju1" :key="index">{{item=='n'?"":item}}</li> -->
                  &nbsp;&nbsp;次
                </ul>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div>
      <!-- <home-left :CarCount="CarCount"
                 :geoDis="VehAreaDistion.geoDistribution"
                 :TrendChange="TrendChange">
      </home-left> -->
      <home-center :VehAreaDistion="VehAreaDistion"></home-center>
      <!-- <home-right :socStart="socStart"
                  :monitorStat = "monitorStat"
                  :CitySta="CitySta"
                  :MonthSta="MonthSta"
                  :chargeState="chargeState"
                  @driveChange="driveChange"
                  >
      </home-right> -->
    </div>
  </div>
</template>

<script>
import api from '../api'
import dayjs from 'dayjs'

import akHeader from '@/component/header'
// import homeLeft from './homeLeft'
import homeCenter from './homeCenter'
// import homeRight from './homeRight'
export default {
  name: 'homeContent',
  components: { akHeader, homeCenter },
  data () {
    return {
      homeLoading: false,
      CarCount: {},
      socStart: [],
      shuju1: ['1', '9', ',', '0', '8', '9'],
      shuju2: ['0', ',', '0', '0', '6', ',', '3', '8', '9'],
      chargeState: [],
      monitorStat: [],
      VehAreaDistion: {
        chargeStatistics: [],
        drivStatistics: [],
        geoDistribution: {}
      },
      TrendChange: {
        travlChange: [],
        regisMonitor: []
      },
      CitySta: {
        charge: [],
        travel: []
      },
      MonthSta: {
        charge: [],
        travel: []
      },
      timer: null,
      duration: 10000
    }
  },
  mounted () {
    this.setStaticData()
  },
  destroyed () {
    this.timer && clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    fanhui (type) {
      this.homeLoading = true
      setTimeout(() => {
        this.homeLoading = false
        if (type === 'homeContainer') {
          this.$router.push({ path: '/homeSecurity' })
        } else {
          this.$router.push({ path: '/homeContent' })
        }
      }, 600)
    },
    setStaticData () {
      const self = this
      let lastDay = new Date() - 1000 * 60 * 60 * 24
      let date = dayjs(lastDay).format('YYYY-MM-DD')
      let now = new Date().getTime()
      let day = dayjs(now).format('YYYY-MM-DD HH:mm:ss')
      // const day = '2019-04-19 12:00:00'
      const getStaticeData = async function () {
        // const CarCount = await api.getCarCount()
        api.getCarCount().then(function (res) {
          if (res.data.meta.code === 200) {
            self.CarCount = res.data.data
          }
        })
        // const SocChargeStartState = await api.getSocChargeStartState({
        //   selectDate: date
        // })
        api.getSocChargeStartState({
          selectDate: date
        }).then(function (res) {
          if (res.data.meta.code === 200) {
            self.socStart = res.data.data
          }
        })
        api.getMonitorStat({
        }).then(function (res) {
          if (res.data.meta.code === 200) {
            self.monitorStat = res.data.data
          }
        })
        // const ChargeState = await api.getChargeState({ date: date })
        api.getChargeState({ date: date }).then(function (res) {
          if (res.data.meta.code === 200) {
            self.chargeState = res.data.data
          }
        })
        // const VehAreaDistion = await api.getVehAreaDistion()
        api.getVehAreaDistion().then(function (res) {
          if (res.data.meta.code === 200) {
            self.VehAreaDistion = res.data.data
            if (self.VehAreaDistion && self.VehAreaDistion.geoDistribution && self.VehAreaDistion.geoDistribution.data && self.VehAreaDistion.geoDistribution.data.length > 0) {
              // 为了适配echarts漏洞，第一个设置为空
              self.VehAreaDistion.geoDistribution.data[0].unshift('')
              self.VehAreaDistion.geoDistribution.data[1].unshift('')
              self.VehAreaDistion.geoDistribution.cityArray.unshift('')
              // 为了适配echarts漏洞，最后一个设置为空
              self.VehAreaDistion.geoDistribution.data[0].push('')
              self.VehAreaDistion.geoDistribution.data[1].push('')
              self.VehAreaDistion.geoDistribution.cityArray.push('')
            }
          }
        })
        // const TrendChangeSta = await api.getTrendChangeSta({ date: day })

        // 汽车监控总量变化趋势
        api.getTrendChangeSta({ date: day }).then(function (res) {
          if (res.data.meta.code === 200) {
            self.TrendChange = res.data.data
          }
        })
        // const CitySta = await api.getCitySta({ date: date })
        api.getCitySta({ date: date, type: 5 }).then(function (res) {
          if (res.data.meta.code === 200) {
            self.CitySta = res.data.data
          }
        })
        // const MonthSta = await api.getMonthSta({ date: date })
        api.getMonthSta({ date: date, type: 5 }).then(function (res) {
          if (res.data.meta.code === 200) {
            self.MonthSta = res.data.data
          }
        })

        // self.CarCount = CarCount.data.data
        // self.chargeState = ChargeState.data.data
        // self.socStart = SocChargeStartState.data.data
        // self.VehAreaDistion = VehAreaDistion.data.data
        // self.TrendChange = TrendChangeSta.data.data
        // self.CitySta = CitySta.data.data
        // self.MonthSta = MonthSta.data.data
        // this.homeLoading = false
      }
      getStaticeData()
      this.setTimer()
    },
    setRealTimeData () {
      const self = this
      let now = new Date().getTime()
      let day = dayjs(now).format('YYYY-MM-DD HH:mm:ss')
      const getStaticeData = async function () {
        const CarCount = await api.getCarCount()
        const TrendChangeSta = await api.getTrendChangeSta({ date: day })
        self.CarCount = CarCount.data.data
        self.TrendChange = TrendChangeSta.data.data
      }
      getStaticeData()
    },
    setTimer () {
      this.timer = setInterval(this.setRealTimeData, this.duration)
    },
    // 汽车行驶情况月度统计
    driveChange (val) {
      api.getMonthSta({ date: dayjs(new Date() - 1000 * 60 * 60 * 24).format('YYYY-MM-DD'), type: Number(val) }).then((res) => {
        if (res.data.meta.code === 200) {
          this.MonthSta = res.data.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-content {
  & > div {
    display: flex;
  }
}
</style>

<style lang="scss" scoped>
.home-left {
  // width: 10.65rem;
  .overall {
    width: 100%;
    height: 1.53rem;
    padding: 0 0.28rem;
    box-sizing: border-box;
    background: url("../../../assets/images/home/bg-1.png") no-repeat;
    background-size: 100% 100%;
    .home-monitor {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      .home-monitor-list {
        // width: 10.17rem;
        width: 100%;
        margin-bottom: 0.34rem;
        margin-top: -0.2rem;
        & > div {
          font-size: 0.26rem;
          color: #62d5ff;
          text-align: center;
          line-height: 0.5rem;
        }
      }
      .home-monitor-num {
        display: flex;
        width: 3.17rem;
        text-align: center;
        height: 0.8rem;
        padding: 0.1rem 0.27rem;
        box-sizing: border-box;
        border: 0.01rem solid #0fc9e4;
        border: none;
        justify-content: space-around;
        li {
          width: 0.4rem;
          font-family: myFont;
          line-height: 0.6rem;
          font-size: 0.6rem;
          height: 0.6rem;
          background: url("../../../assets/images/home/num.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .city-card {
    width: 100%;
    height: 4.5rem;
    padding: 0 0.28rem;
    box-sizing: border-box;
    background: url("../../../assets/images/home/bg-1.png") no-repeat;
    background-size: 100% 100%;
    margin: 0.34rem 0;
    & > div {
      display: flex;
    }
    .city-card-travel {
      // width: 9rem;
      width: 5rem;
      height: 3.5rem;
    }
  }
  .card-sales {
    width: 100%;
    height: 4.1rem;
    padding: 0 0.28rem 0.44rem 0.28rem;
    box-sizing: border-box;
    background: url("../../../assets/images/home/bg-1.png") no-repeat;
    background-size: 100% 100%;
    .card-sales-box {
      width: 100%;
      height: 3rem;
    }
  }
}
.overallHeader {
  background-size: cover !important;
}
</style>
